<template>
  <div class="home-view">
    <!-- Welcome Header - Fehér háttér -->
    <div class="welcome-header">
      <div class="welcome-content">
        <h1 class="welcome-title">
          Üdvözöljük, <span class="company-name">{{ partner.last_name || 'Partnerkapunkon' }}</span>!
        </h1>
        <p class="welcome-subtitle">{{ getGreeting() }}</p>
      </div>
      <div class="quick-actions">
        <button class="quick-action-btn primary" @click="$router.push('/projects/create')">
          <i class="fas fa-plus"></i>
          <span>Új projekt</span>
        </button>
      </div>
    </div>

    <!-- Modern Tab Navigation - mint a képen -->
    <div class="tabs-container">
      <div class="tabs-navigation">
        <button v-for="tab in tabs" :key="tab.id" class="tab-button" :class="{ active: activeTab === tab.id }"
          @click="switchTab(tab.id)">
          <i :class="tab.icon"></i>
          <span>{{ tab.label }}</span>
          <span v-if="tab.badge" class="tab-badge">{{ tab.badge }}</span>
        </button>
      </div>

      <!-- Tab Content -->
      <div class="tab-content">
        <!-- Projektek Tab -->
        <transition name="fade" mode="out-in">
          <div v-if="activeTab === 'projects'" class="tab-panel" key="projects">
            <ProjectsCard :inline="true" />
          </div>

          <!-- E-havi számlák Tab -->
          <div v-else-if="activeTab === 'invoices'" class="tab-panel" key="invoices">
            <InvoiceCard :inline="true" />
          </div>

          <!-- Árlisták Tab -->
          <div v-else-if="activeTab === 'pricelists'" class="tab-panel" key="pricelists">
            <FileCard type="Redőny,Szúnyogháló,Redőnykapu,Zsaluzia,Zipscreen,Reluxa,Roletta,Sávroló,Napellenző,Pergola,Szalagfüggöny" />
            <!-- <div class="pricelists-grid">
              <div v-for="pricelist in pricelists" :key="pricelist.id" class="pricelist-card">
                <div class="pricelist-icon">
                  <i class="fas fa-file-pdf"></i>
                </div>
                <div class="pricelist-content">
                  <h3 class="pricelist-title">{{ pricelist.title }}</h3>
                  <p class="pricelist-description">{{ pricelist.description }}</p>
                  <div class="pricelist-meta">
                    <span class="pricelist-date">
                      <i class="far fa-calendar"></i>
                      {{ formatDate(pricelist.valid_from) }}
                    </span>
                    <span class="pricelist-size">{{ pricelist.size }}</span>
                  </div>
                </div>
                <button class="pricelist-download" @click="downloadPricelist(pricelist)">
                  <i class="fas fa-download"></i>
                </button>
              </div>
            </div> -->
          </div>

          <!-- Segédletek Tab -->
          <div v-else-if="activeTab === 'resources'" class="tab-panel" key="resources">
            <FileCard type="Szerelési segédlet,Oktató anyag,Dokumentum,Kézikönyv,Egyéb" />
            <!-- <div class="resources-grid">
              <div v-for="resource in resources" :key="resource.id" class="resource-card">
                <div class="resource-icon" :class="resource.type">
                  <i :class="resource.icon"></i>
                </div>
                <div class="resource-content">
                  <h3 class="resource-title">{{ resource.title }}</h3>
                  <p class="resource-description">{{ resource.description }}</p>
                  <div class="resource-meta">
                    <span class="resource-type">{{ resource.typeLabel }}</span>
                    <span class="resource-size" v-if="resource.size">{{ resource.size }}</span>
                  </div>
                </div>
                <button class="resource-action" @click="openResource(resource)">
                  <i class="fas fa-download" v-if="resource.type === 'download'"></i>
                  <i class="fas fa-external-link-alt" v-else></i>
                </button>
              </div>
            </div> -->
          </div>

          <!-- Kapcsolat Tab -->
          <div v-else-if="activeTab === 'contact'" class="tab-panel" key="contact">
            <div class="contact-container">
              <div class="contact-header">
                <h2 class="contact-title">Kapcsolatfelvétel</h2>
                <p class="contact-subtitle">Forduljon hozzánk bizalommal bármilyen kérdéssel!</p>
              </div>

              <div class="contact-grid">
                <!-- Elérhetőségek -->
                <div class="contact-card">
                  <div class="contact-card-header">
                    <i class="fas fa-building"></i>
                    <h3>Központi iroda</h3>
                  </div>
                  <div class="contact-info">
                    <div class="info-item">
                      <i class="fas fa-map-marker-alt"></i>
                      <div>
                        <strong>Cím:</strong><br>
                        Budapest, Légcsavar u. 5, 1165
                      </div>
                    </div>
                    <div class="info-item">
                      <i class="fas fa-phone"></i>
                      <div>
                        <strong>Telefon:</strong><br>
                        <a href="tel:+36302131140">+36 30 213 1140</a>
                      </div>
                    </div>
                    <div class="info-item">
                      <i class="fas fa-envelope"></i>
                      <div>
                        <strong>E-mail:</strong><br>
                        <a href="mailto:megrendeles@redrel.hu">megrendeles@redrel.hu</a>
                      </div>
                    </div>
                    <div class="info-item">
                      <i class="fas fa-clock"></i>
                      <div>
                        <strong>Nyitvatartás:</strong><br>
                        Hétfő - Péntek: 7:00 - 16:00
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Ügyvezető -->
                <div class="contact-card">
                  <div class="contact-card-header">
                    <i class="fas fa-user-tie"></i>
                    <h3>Ügyvezető</h3>
                  </div>
                  <div class="contact-info">
                    <div class="info-item">
                      <i class="fas fa-user"></i>
                      <div>
                        <strong>Kajkó Áron</strong><br>
                        Ügyvezető igazgató
                      </div>
                    </div>
                    <div class="info-item">
                      <i class="fas fa-envelope"></i>
                      <div>
                        <strong>E-mail:</strong><br>
                        <a href="mailto:aron.kajko@redrel.hu">aron.kajko@redrel.hu</a>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Gyors kapcsolat -->
                <div class="contact-card full-width">
                  <div class="contact-card-header">
                    <i class="fas fa-comments"></i>
                    <h3>Gyors kapcsolatfelvétel</h3>
                  </div>
                  <div class="quick-contact">
                    <button class="contact-btn primary" @click="openEmailClient">
                      <i class="fas fa-envelope"></i>
                      E-mail küldése
                    </button>
                    <button class="contact-btn secondary" @click="makePhoneCall">
                      <i class="fas fa-phone"></i>
                      Telefonhívás
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/services/apiService';
import ProjectsCard from '@/components/home/ProjectsCard.vue';
import InvoiceCard from '@/components/home/InvoiceCard.vue';
import FileCard from '@/components/home/FileCard.vue';

export default {
  name: 'HomeView',
  components: {
    ProjectsCard,
    InvoiceCard,
    FileCard
  },
  data() {
    return {
      activeTab: 'projects',
      isRefreshing: false,
      partner: JSON.parse(localStorage.getItem('user')) || {},
      selectedMonth: new Date().getMonth() + 1,
      selectedYear: new Date().getFullYear(),

      tabs: [
        { id: 'projects', label: 'Projektek', icon: 'fas fa-project-diagram', badge: null },
        { id: 'invoices', label: 'Számlák', icon: 'fas fa-file-invoice-dollar', badge: null },
        { id: 'pricelists', label: 'Árlisták', icon: 'fas fa-tags', badge: null },
        { id: 'resources', label: 'Műszaki katalógusok', icon: 'fas fa-book', badge: null },
        { id: 'contact', label: 'Kapcsolat', icon: 'fas fa-book', badge: null }
      ]  
    }
  },
  computed: {
    currentMonthName() {
      const months = ['Január', 'Február', 'Március', 'Április', 'Május', 'Június',
        'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'];
      return `${months[this.selectedMonth - 1]} ${this.selectedYear}`;
    }
  },
  async mounted() {
    await this.loadTabBadges();
  },
  methods: {
    getGreeting() {
      const hour = new Date().getHours();
      if (hour < 10) return 'Jó reggelt kívánunk!';
      if (hour < 18) return 'Szép napot kívánunk!';
      return 'Szép estét kívánunk!';
    },

    switchTab(tabId) {
      this.activeTab = tabId;
    },

    async refreshContent() {
      this.isRefreshing = true;
      await this.loadTabBadges();
      setTimeout(() => {
        this.isRefreshing = false;
      }, 1000);
    },

    async loadTabBadges() {
      try {
        // Projektek számának betöltése
        const projectsResponse = await apiService.get('/projects/upcoming-projects');
        if (projectsResponse.success) {
          const projectTab = this.tabs.find(t => t.id === 'projects');
          if (projectTab) {
            projectTab.badge = projectsResponse.data.total_projects;
          }
        }

        // Számlák számának betöltése
        const invoicesResponse = await apiService.get('/invoices/monthly');
        if (invoicesResponse.success) {
          const invoiceTab = this.tabs.find(t => t.id === 'invoices');
          if (invoiceTab && invoicesResponse.data.invoices) {
            invoiceTab.badge = invoicesResponse.data.summary.total.count;
          }
        }
      } catch (error) {
        console.error('Hiba a badge-ek betöltésekor:', error);
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('hu-HU', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },

    changeMonth(direction) {
      this.selectedMonth += direction;
      if (this.selectedMonth > 12) {
        this.selectedMonth = 1;
        this.selectedYear++;
      } else if (this.selectedMonth < 1) {
        this.selectedMonth = 12;
        this.selectedYear--;
      }
    },

    downloadPricelist(pricelist) {
      this.$swal.fire({
        title: 'Letöltés',
        text: `A(z) "${pricelist.title}" letöltése hamarosan elérhető lesz.`,
        icon: 'info',
        confirmButtonText: 'Rendben'
      });
    },

    openResource(resource) {
      if (resource.type === 'download') {
        this.$swal.fire({
          title: 'Letöltés',
          text: `A(z) "${resource.title}" letöltése hamarosan elérhető lesz.`,
          icon: 'info',
          confirmButtonText: 'Rendben'
        });
      } else {
        this.$swal.fire({
          title: resource.title,
          text: resource.description,
          icon: 'info',
          confirmButtonText: 'Rendben'
        });
      }
    },

    openEmailClient() {
      window.location.href = 'mailto:megrendeles@redrel.hu?subject=Megkeresés a partner portálról';
    },

    makePhoneCall() {
      window.location.href = 'tel:+36302131140';
    }
  }
}
</script>

<style scoped>
.home-view {
  min-height: 100vh;
}

/* Welcome Header - Fehér háttér */
.welcome-header {
  /* background: white; */
  border-radius: 20px;
  padding: 2.5rem 0;
  margin-bottom: 2rem;

  margin-left: 1.25rem;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.welcome-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  margin-bottom: 0.5rem;
  color: #333;
}

.company-name {
  color: #1d4699;
  font-weight: 800;
}

.welcome-subtitle {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}

.quick-actions {
  display: flex;
  gap: 1rem;
}

.quick-action-btn {
  padding: 0.875rem 1.5rem;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.quick-action-btn.primary {
  background: #1d4699;
  color: white;
}

.quick-action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(29, 70, 153, 0.3);
}

/* Tabs Container */
.tabs-container {
  background: white;
  border-radius: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Tab Navigation - mint a képen, csak aláhúzással */
.tabs-navigation {
  display: flex;
  padding: 1rem 1rem 0 1rem;
  gap: 2rem;
  background: white;
  border-bottom: 1px solid #e9ecef;
  overflow-x: auto;
}

.tab-button {
  padding: 1rem 0;
  border: none;
  background: transparent;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  position: relative;
  font-size: 0.95rem;
  white-space: nowrap;
  border-bottom: 3px solid transparent;
}

.tab-button:hover {
  color: #1d4699;
}

.tab-button.active {
  color: #1d4699;
  border-bottom-color: #1d4699;
  font-weight: 600;
}

.tab-badge {
  background: #ffc107;
  color: #333;
  border-radius: 12px;
  padding: 0.2rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  margin-left: 0.25rem;
  min-width: auto;
}

.tab-button.active .tab-badge {
  background: #ffc107;
  color: #333;
}

/* Tab Content */
.tab-content {
  padding: 2rem;
  min-height: 500px;
}

.tab-panel {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Pricelists Grid */
.pricelists-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.pricelist-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  gap: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.pricelist-card:hover {
  border-color: #1d4699;
  box-shadow: 0 5px 20px rgba(29, 70, 153, 0.15);
  transform: translateY(-2px);
}

.pricelist-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
  background: linear-gradient(135deg, #1d4699 0%, #163980 100%);
  color: white;
}

.pricelist-content {
  flex: 1;
}

.pricelist-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.pricelist-description {
  color: #6c757d;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 0.75rem;
}

.pricelist-meta {
  display: flex;
  gap: 1rem;
  font-size: 0.875rem;
}

.pricelist-date {
  color: #1d4699;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.pricelist-size {
  color: #6c757d;
}

.pricelist-download {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #1d4699;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.pricelist-download:hover {
  background: #1d4699;
  color: white;
  border-color: #1d4699;
}

/* Resources Grid */
.resources-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.resource-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  gap: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.resource-card:hover {
  border-color: #1d4699;
  box-shadow: 0 5px 20px rgba(29, 70, 153, 0.15);
  transform: translateY(-2px);
}

.resource-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
}

.resource-icon.guide {
  background: linear-gradient(135deg, #1d4699 0%, #163980 100%);
  color: white;
}

.resource-icon.download {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
}

.resource-icon.link {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
}

.resource-content {
  flex: 1;
}

.resource-title {
  font-size: 1.125rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.resource-description {
  color: #6c757d;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 0.75rem;
}

.resource-meta {
  display: flex;
  gap: 1rem;
  font-size: 0.875rem;
}

.resource-type {
  color: #1d4699;
  font-weight: 600;
}

.resource-size {
  color: #6c757d;
}

.resource-action {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #1d4699;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.resource-action:hover {
  background: #1d4699;
  color: white;
  border-color: #1d4699;
}

/* Contact Styles */
.contact-container {
  max-width: 1000px;
  margin: 0 auto;
  width: 100%; /* Hozzáadva */
}

.contact-header {
  text-align: center;
  margin-bottom: 3rem;
}

.contact-title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
}

.contact-subtitle {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); /* Csökkentett min-width */
  gap: 2rem;
  width: 100%; /* Hozzáadva */
}

.contact-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  width: 100%; /* Hozzáadva */
  box-sizing: border-box; /* Hozzáadva */
}

.contact-card:hover {
  box-shadow: 0 5px 20px rgba(29, 70, 153, 0.1);
  transform: translateY(-2px);
}

.contact-card.full-width {
  grid-column: 1 / -1;
}

.contact-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
  flex-wrap: wrap; /* Hozzáadva */
}

.contact-card-header i {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1d4699 0%, #163980 100%);
  color: white;
  font-size: 1.25rem;
  flex-shrink: 0; /* Hozzáadva */
}

.contact-card-header h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #333;
  margin: 0;
  flex: 1; /* Hozzáadva */
  min-width: 0; /* Hozzáadva */
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.info-item {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  width: 100%; /* Hozzáadva */
}

.info-item i {
  width: 20px;
  color: #1d4699;
  font-size: 1rem;
  margin-top: 0.2rem;
  flex-shrink: 0;
}

.info-item div {
  flex: 1;
  line-height: 1.5;
  min-width: 0; /* Hozzáadva */
  word-wrap: break-word; /* Hozzáadva */
}

.info-item strong {
  color: #333;
  font-weight: 600;
}

.info-item a {
  color: #1d4699;
  text-decoration: none;
  font-weight: 500;
  word-break: break-all; /* Hozzáadva */
}

.info-item a:hover {
  text-decoration: underline;
}

.quick-contact {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap; /* Hozzáadva */
}

.contact-btn {
  padding: 1rem 2rem;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  font-size: 1rem;
  min-width: 0; /* Hozzáadva */
  flex-shrink: 0; /* Hozzáadva */
}

.contact-btn.primary {
  background: #1d4699;
  color: white;
}

.contact-btn.secondary {
  background: #f8f9fa;
  color: #1d4699;
  border: 1px solid #e9ecef;
}

.contact-btn:hover {
  transform: translateY(-2px);
}

.contact-btn.primary:hover {
  box-shadow: 0 5px 15px rgba(29, 70, 153, 0.3);
}

.contact-btn.secondary:hover {
  background: #e9ecef;
  border-color: #1d4699;
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .home-view {
    padding: 1rem;
  }

  .welcome-header {
    flex-direction: column;
    gap: 1.5rem;
    text-align: center;
  }

  .welcome-title {
    font-size: 1.5rem;
  }

  .tabs-navigation {
    flex-wrap: wrap;
    justify-content: center;
  }

  .tab-button {
    min-width: auto;
    font-size: 0.875rem;
  }

  .tab-content {
    padding: 1rem;
  }

  .pricelists-grid,
  .resources-grid {
    grid-template-columns: 1fr;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem; /* Csökkentett gap */
  }

  .contact-card {
    padding: 1.5rem; /* Csökkentett padding */
  }

  .contact-title {
    font-size: 1.75rem; /* Csökkentett méret */
  }

  .contact-subtitle {
    font-size: 1rem; /* Csökkentett méret */
  }

  .contact-card-header h3 {
    font-size: 1.125rem; /* Csökkentett méret */
  }

  .quick-contact {
    flex-direction: column; /* Egymás alá rendezés kis képernyőn */
    align-items: stretch; /* Teljes szélességű gombok */
  }

  .contact-btn {
    padding: 0.875rem 1.5rem; /* Csökkentett padding */
    font-size: 0.95rem; /* Csökkentett méret */
    justify-content: center; /* Középre igazítás */
  }
}

/* Extra kis képernyők kezelése */
@media (max-width: 480px) {
  .contact-container {
    padding: 0 0.5rem; /* Extra padding kis képernyőkön */
  }

  .contact-grid {
    gap: 1rem;
  }

  .contact-card {
    padding: 1rem;
  }

  .contact-card-header {
    gap: 0.5rem;
  }

  .info-item {
    gap: 0.75rem;
  }

  .contact-btn {
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
  }
}
</style>